import React from 'react';

const SVG = ({ style = {}, size, color = 'rgb(216, 153, 164)', width = '100%', viewBox = '0 0 100 100' }) => {
  const d = 100 / 7;
  return (
    <svg style={{ ...style, display: 'block' }} width={width} height={width} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
      <g id="tile" stroke={color} strokeWidth="2" fill="none">
        <rect x="1" y="1" width="98" height="98" fill="rgba(0,0,0, 0.1)" />
        <g opacity={size === 3 ? 1 : 0}>
          <line x1="33.333" x2="33.333" y2="100" />
          <line x1="66.666" x2="66.666" y2="100" />

          <line y1="33.333" x2="100" y2="33.333" />
          <line y1="66.666" x2="100" y2="66.666" />
        </g>
        <g opacity={size === 4 ? 1 : 0}>
          <line x1="25" x2="25" y2="100" />
          <line x1="50" x2="50" y2="100" />
          <line x1="75" x2="75" y2="100" />

          <line y1="25" x2="100" y2="25" />
          <line y1="50" x2="100" y2="50" />
          <line y1="75" x2="100" y2="75" />
        </g>
        <g opacity={size === 5 ? 1 : 0}>
          <line x1="20" x2="20" y2="100" />
          <line x1="40" x2="40" y2="100" />
          <line x1="60" x2="60" y2="100" />
          <line x1="80" x2="80" y2="100" />

          <line y1="20" x2="100" y2="20" />
          <line y1="40" x2="100" y2="40" />
          <line y1="60" x2="100" y2="60" />
          <line y1="80" x2="100" y2="80" />
        </g>
        <g opacity={size === 6 ? 1 : 0}>
          <line x1="16.666" x2="16.666" y2="100" />
          <line x1="33.333" x2="33.333" y2="100" />
          <line x1="50" x2="50" y2="100" />
          <line x1="66.666" x2="66.666" y2="100" />
          <line x1="83.333" x2="83.333" y2="100" />

          <line y1="16.666" x2="100" y2="16.666" />
          <line y1="33.333" x2="100" y2="33.333" />
          <line y1="50" x2="100" y2="50" />
          <line y1="66.666" x2="100" y2="66.666" />
          <line y1="83.333" x2="100" y2="83.333" />
        </g>
        <g opacity={size === 7 ? 1 : 0}>
          <line x1={16} x2={16} y2="100" />
          <line x1={29.5} x2={29.5} y2="100" />
          <line x1={43} x2={43} y2="100" />
          <line x1={56.5} x2={56.5} y2="100" />
          <line x1={70} x2={70} y2="100" />
          <line x1={84} x2={84} y2="100" />

          <line y1={16} x2="100" y2={16} />
          <line y1={29.5} x2="100" y2={29.5} />
          <line y1={43} x2="100" y2={43} />
          <line y1={56.5} x2="100" y2={56.5} />
          <line y1={70} x2="100" y2={70} />
          <line y1={84} x2="100" y2={84} />
        </g>
      </g>
    </svg>
  );
};

export default SVG;
